import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateIndividual } from "common/services/individuals.service";
import PaymentForm from "./IndividualForm";
import { toast } from "react-toastify";
import { extractFieldErrors } from "common/lib/fieldErrors";

const UpdateIndividual: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldErrors, setFieldErrors] = useState<any>([]);
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      fullName: selectedRecord?.fullName,
      gender: selectedRecord?.gender,
      passportOrIdNumber: selectedRecord?.passportOrIdNumber,
      emailAddress: selectedRecord?.emailAddress,
      phoneNumber: selectedRecord?.phoneNumber,
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Please enter full name"),
      gender: Yup.string().nullable(),
      passportOrIdNumber: Yup.string().nullable(),
      emailAddress: Yup.string().nullable(),
      phoneNumber: Yup.string().nullable(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          fullName: values.fullName ? values.fullName.trim() : null,
          gender: values?.gender || "Unknown",
          passportOrIdNumber: values?.passportOrIdNumber
            ? values?.passportOrIdNumber.trim()
            : null,
          emailAddress: values?.emailAddress
            ? values?.emailAddress.trim()
            : null,
          phoneNumber: values?.phoneNumber ? values?.phoneNumber.trim() : null,
        },
      };

      setLoading(true);
      try {
        await updateIndividual(selectedRecord?.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Individual updated successfully", {});
      } catch (e: any) {
        const errors = extractFieldErrors(e?.response);
        setFieldErrors(errors);
        toast.error("Individual update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Indivdual
      </ModalHeader>

      <PaymentForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
        fieldErrors={fieldErrors}
      />
    </Modal>
  );
};

export default UpdateIndividual;
